import request from '@/utils/request'

export function getMessageList(query) {
  return request({
    url: '/vue-element-admin/message/list',
    method: 'get',
    params: query
  })
}

export function getLocation() {
  return request({
    url: '/vue-element-admin/message/getLocation',
    method: 'get',
  })
}
